import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';
import { Subject } from 'rxjs';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
@Component({
  selector: 'blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})

export class BlogComponent implements OnInit {
  idiomaBanner:any;
  private _unsubscribeAll: Subject<any>;
  constructor(
    private activated: ActivatedRoute,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
    ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });

    this._unsubscribeAll = new Subject();
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

  }

 ngOnInit() {
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
 }

 cambiaIdiomaBanner(idioma:string){
  this.idiomaBanner = this.translateSrv.currentLang; 
  switch(idioma){
    case 'es': this.idiomaBanner = idioma; 
    break;
    default: this.idiomaBanner = 'en';
  }
  this.getBanner();
}
urlBanner:any;
getBanner(){
  this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-04.png';
}

  dataDef = [
    {
      position: 1, 
      tittle: 'WIZARD.DEFINICIONES_NORMA.DEF1.TITLE_DEF',
      definicion: 'WIZARD.DEFINICIONES_NORMA.DEF1.DEF', 
   
    },
    {
      position: 2,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF2.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF2.DEF",
    },
    {
      position: 3,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF3.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF3.DEF"
    },
    {
      position: 4,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF4.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF4.DEF"

    },
    {
      position: 5,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF5.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF5.DEF"
    },{
      position: 6,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF6.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF6.DEF"
    },{
      position: 7,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF7.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF7.DEF"
    },{
      position: 8,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF8.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF8.DEF"
    },{
      position: 9,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF9.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF9.DEF"
    },
    {
      position: 10,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF10.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF10.DEF"
    },{
      position: 11,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF11.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF11.DEF"
    },{
      position: 12,
      tittle: "WIZARD.DEFINICIONES_NORMA.DEF12.TITLE_DEF",
      definicion: "WIZARD.DEFINICIONES_NORMA.DEF12.DEF"
    }
  ]

  dataId : any ;
  

}
